import React, { Suspense } from 'react';
import { TimeLazyLoad } from '../../../common/lazy-load-timing';
import { LoadingSpinner } from '../../../common/loading-spinner';
import { dateFormatter } from '../utils/date-formatter';
import type { JiraSearchDialogProps } from './jira-search-dialog-types';

const JiraComponent = React.lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/extensible/async/jira-dialog" */ './jira-search-dialog'
	).then(({ JiraSearchDialogWithQueryContext }) => ({
		default: JiraSearchDialogWithQueryContext,
	})),
);

export const JiraAsyncWrapper = (props: JiraSearchDialogProps) => (
	<Suspense
		fallback={
			<TimeLazyLoad product="jira">
				<LoadingSpinner />
			</TimeLazyLoad>
		}
	>
		<JiraComponent {...props} debounceTime={250} formatDate={props.formatDate || dateFormatter} />
	</Suspense>
);
